import React from "react";

const CmykTopBar = ({ width = 500, height = 20, gap = 10 }) => {
  const colors = ["#00FFFF", "#FF00FF", "#FFFF00","#000000" ]; // Black, Yellow, Magenta, Cyan
  const rectsPerColor = 4; // Number of rectangles per color
  const totalColorWidth = (width - gap * (colors.length - 1)) / colors.length; // Width allocated per color group
  const rectWidth = totalColorWidth / rectsPerColor; // Width of each rectangle within a color group

  return (
    <svg
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      xmlns="http://www.w3.org/2000/svg"
    >
      {colors.map((color, colorIndex) =>
        Array.from({ length: rectsPerColor }).map((_, i) => {
          const opacity = 1 - i * 0.25; // Gradation from 1.0 to 0.25
          const xPosition =
            colorIndex * (totalColorWidth + gap) + i * rectWidth; // Adjust position for gaps between colors

          return (
            <rect
              key={`${color}-${i}`}
              x={xPosition}
              y="0"
              width={rectWidth}
              height={height}
              fill={color}
              opacity={opacity}
            />
          );
        })
      )}
    </svg>
  );
};

export default CmykTopBar;
